import React from "react";
import Inicio from "../../component/inicio/Inicio";

const Graficas = () => {
  return (
    <>
      <h2 className="sectionTitle">Gráficas</h2>
      <Inicio />
    </>
  );
};

export default Graficas;
